import { Text } from '@mantine/core';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import { AuditLogType } from '@portals/types';

interface AddUserToGroupProps {
  auditLog: AuditLogType;
}

export const AddUserToGroup: FC<AddUserToGroupProps> = ({ auditLog }) => (
  <Text size="sm">
    Added {auditLog?.params[0]?.model}:{' '}
    <Text<typeof Link>
      size="sm"
      component={Link}
      to="/settings/users_and_groups/users"
      color="blue"
      underline
    >
      {auditLog?.params[0]?.display_name}
    </Text>{' '}
    to {auditLog?.params[1]?.model}: {auditLog?.params[1]?.display_name}
  </Text>
);
